import React from "react";
import {
    SELECTED_ELEMENT_COLOR,
    defaultObjectSizes,
    OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as ShowerIcon } from "../../Assets/Душ.svg";

const ShowerRenderer = ({
    element,
    scale,
    isSelected,
    wallThickness,
    placementSideFactor,
    orientation,
}) => {
    const defaults = defaultObjectSizes[OBJECT_TYPES.SHOWER];
    const elementVisualWidthM = element.width || defaults.width;
    const elementPlanDepthM = element.depth || defaults.depth;

    const elementVisualWidthPx = elementVisualWidthM * scale;
    const elementPlanDepthPx = elementPlanDepthM * scale;
    const wallThicknessPx = wallThickness * scale;

    const yOffset =
        placementSideFactor * (wallThicknessPx / 2 + elementPlanDepthPx / 2);

    const iconStyle = {
        fill: isSelected ? "rgba(0, 123, 255, 0.15)" : "#E5E7EB",
        stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",
        strokeWidth: isSelected ? 1.2 : 0.9,
        pointerEvents: "none",
    };

    let rotationAngle;
    if (orientation === 'v') {
        rotationAngle = placementSideFactor === 1 ? 90 : -90;
    } else {
        rotationAngle = placementSideFactor === 1 ? 90 : -90;
    }

    const groupTransform = `translate(0, ${yOffset}) rotate(${rotationAngle})`;

    return (
        <g transform={groupTransform}>
            <rect
                x={-elementVisualWidthPx / 2}
                y={-elementPlanDepthPx / 2}
                width={elementVisualWidthPx}
                height={elementPlanDepthPx}
                fill="transparent"
            />

            <ShowerIcon
                x={-elementVisualWidthPx / 2}
                y={-elementPlanDepthPx / 2}
                width={elementVisualWidthPx}
                height={elementPlanDepthPx}
                style={iconStyle}
                preserveAspectRatio="xMidYMid meet"
            />
        </g>
    );
};

export default React.memo(ShowerRenderer);
